module.exports = __webpack_public_path__ + "static/media/1p.5350f7ed.jpg";